import { render, staticRenderFns } from "./DealForm.vue?vue&type=template&id=0aa17a60&scoped=true&"
import script from "./DealForm.vue?vue&type=script&lang=js&"
export * from "./DealForm.vue?vue&type=script&lang=js&"
import style0 from "./DealForm.vue?vue&type=style&index=0&id=0aa17a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa17a60",
  null
  
)

component.options.__file = "DealForm.vue"
export default component.exports